<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Events'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_0"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">CorDx Events</div>
				<div class="txt">Transforming Global Diagnostics</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"	
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/Event.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div v-for="(value, index) in eventsData" :key="index" :class="value.image != '' ? 'block_2_el' : 'block_1_el'">
					<img v-if="value.image" class="img_bg" :src="value.image" />
					<div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 80%;">
						<div class="tit">{{ value.title }}</div>
						<div class="txt">{{ value.shijian }}</div>
						<div class="txt">{{ value.address }}</div>
						<div class="txt">{{ value.zhanhuihao }}</div>
						<div class="btn_box_more btn_box" @click="goEventsInfo(value)">
							Learn More<img v-if="value.image != ''" src="../../assets/img/20230817-131946.png" /><img v-if="value.image == ''" src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="left"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Contact us</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x.png" />
						</div>
						<div class="tit_box">5900 Windward Pkwy, Alpharetta, GA 30005</div>
					</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x.png" />
						</div>
						<div class="tit_box">9540 Waples St. #C, San Diego, CA 92121</div>
					</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x (1).png" />
						</div>
						<div class="tit_box">+1 (800) 711-5355</div>
					</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x (2).png" />
						</div>
						<div class="tit_box">info@cordx.com</div>
					</div>
				</div>
				<div class="right">
					<contact titleText="Submit"></contact>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import contact from '@/component/pc/contact.vue'  //联系我们
import { eventsList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			eventsData: [],  //展会数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Events Archive - CorDx';
	},
	mounted() {
		let that = this;
		//查询展会信息
		eventsList({
			language: sessionStorage.getItem('lang'),
		}).then(res => {
			that.eventsData = res.data;
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		goEventsInfo(value) {
			let that = this;
			if(value.url) {
				window.open(value.url, '_blank');
			}else {
				//this.$router.push({ path: '/events-info', query: { id: value.id } });
				let routeData = that.$router.resolve({name: "Eventsinfo", params: { eventsInfoId: value.custom } });
				window.open(routeData.href, '_blank');
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块2*/
	.block_2{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding-bottom: 100px;
		.left{
			width: 400px;
			padding-right: 100px;
			.left_el{
				display: flex;
				align-items: center;
				padding-bottom: 30px;
				.tit_box{
					flex: 1;
					padding-left: 10px;
				}
				.img_box{
					width: 30px;
					img{ width: 100%; }
				}
			}
			.title{
				padding-bottom: 30px;
				font-size: 45px;
				color: #000000;
			}
		}
		.right{
			flex: 1;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		position: relative;
		overflow: hidden;
		margin: 0 auto;
		padding: 100px 0 70px 0;
		text-align: left;
		.block_2_el:hover{
			background-color: rgba(0, 0, 0, 0.3);
		}
		.block_2_el{
			display: inline-block;
			width: 30%;
			height: 300px;
			margin: 0 1.5% 30px 1.5%;
			// padding: 50px 40px 40px 40px;
			text-align: center;
			position: relative;
			background-color: rgba(0, 0, 0, 0.4);
			img.img_bg{
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				z-index: -1;
				object-fit: cover;
			}
			.btn_box{
				margin-top: 25px;
				color: #ffffff;
				border: 1px solid #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
			.btn_box:hover{
				img{
					transform: translateX(6px);
				}
				background-color: transparent;
			}
			.txt{
				padding: 2px 0;
				font-size: 18px;
				color: #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 24px;
				color: #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
		}
		.block_1_el{
			display: inline-block;
			width: 30%;
			height: 300px;
			position: relative;
			margin: 0 1.5% 30px 1.5%;
			padding: 50px 40px 40px 40px;
			background-color: #F2F7FD;
			text-align: center;
			.btn_box{
				margin-top: 30px;
			}
			.txt{
				font-size: 18px;
				color: #000000;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 24px;
				color: #0B318F;
			}
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_0{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 65px;
		}
		.txt{
			font-size: 30px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
